const countries = [
  'Австрия',
  'Германия',
  'Франция', 'Италия', 'Испания', 'Польша', 'Словения', 'Мальта', 
  'США', 'Канада', 'Бразилия', 'Аргентина', 'Бельгия', 'Нидерланды', 'Ирландия', 
  'Кипр', 'Македония', 'Люксембург', 'Дания', 'Лихтенштейн',  
  'Великобритания', 'Австралия', 'Турция', 'Израиль', 'Швеция', 'Норвегия', 'Финляндия',
  'Чехия', 'Словакия', 'Румыния', 'Болгария', 'Греция', 'Португалия', 'Швейцария'
];

export default countries;
